var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"pa-0",attrs:{"color":"RMwhite","min-height":"40","min-width":"40","title":"Screenshot"},on:{"click":function($event){return _vm.captureScreenshot()}}},[_c('v-icon',[_vm._v(" mdi-camera ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }